import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetGlAccountsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.MergeDevAccountDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.MergeDevAccountDocumentSortInput> | Types.MergeDevAccountDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetGlAccountsQuery = { __typename?: 'Query', mergeDevAccounts?: { __typename?: 'MergeDevAccountsConnection', totalCount: number, nodes?: Array<{ __typename?: 'MergeDevAccountDocument', id: string, mergeDevAccountId: string, importId: string, remoteId: string, accountNumber: string, name: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };


export const GetGlAccountsDocument = new TypedDocumentString(`
    query GetGlAccounts($where: MergeDevAccountDocumentFilterInput, $order: [MergeDevAccountDocumentSortInput!], $first: Int, $after: String) {
  mergeDevAccounts(where: $where, order: $order, first: $first, after: $after) {
    nodes {
      id
      mergeDevAccountId
      importId
      remoteId
      accountNumber
      name
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetGlAccounts: build.query<GetGlAccountsQuery, GetGlAccountsQueryVariables | void>({
      query: (variables) => ({ document: GetGlAccountsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetGlAccountsQuery, useLazyGetGlAccountsQuery } = injectedRtkApi;
